import type { CopyShape } from "@tami/core/intl";

import type { TASKS_SCRIPT_COPY_PT_BR } from "../tasks-script.copy";

export const TASKS_SCRIPT_COPY_ES_ES: CopyShape<typeof TASKS_SCRIPT_COPY_PT_BR> = {
  tasksIntro: {
    narrative: "Centro de contenido: accede a todo lo que ya has planificado y encuentra cualquier publicación del historial.",
  },
  tasksGrid: {
    narrative: "Filtra por fecha, estado, mes o campaña — cada tarjeta reúne plataforma, formato y plazo.",
    callout: "Todo el contenido planificado en un solo sitio, con el estado y la campaña a la vista.",
  },
  tasksModalOpen: {
    narrative: "Crea una planificación nueva en segundos — tema, red, formato y plazos en un flujo guiado.",
    callout: "Modal de alta: planifica contenido sin salir del Centro de contenido.",
  },
  tasksModalTitle: {
    narrative: "Empieza por el tema: serie, collab, review o cualquier idea que quieras convertir en contenido.",
    callout: "Define el tema del contenido — el punto de partida de toda planificación.",
  },
  tasksModalCampaign: {
    narrative: "Publis y orgánico en el mismo flujo: vincúlalo a una campaña activa cuando tenga sentido.",
    callout: "Conecta el contenido a una campaña y mantén los entregables organizados.",
  },
  tasksModalPlatform: {
    narrative: "Elige la red adecuada y Tãmi te prepara los formatos disponibles para esa plataforma.",
    callout: "Instagram, TikTok, YouTube y más — elige dónde sale este contenido.",
  },
  tasksModalFormat: {
    narrative: "Reels, stories, feed o vídeo: el formato entra en el plan desde el primer paso.",
    callout: "Elige el tipo de contenido y evita rehacer trabajo a la hora de producir.",
  },
  tasksModalDates: {
    narrative: "Separa la fecha de producción y la de publicación — grabación y publicación en su plazo.",
    callout: "Cuándo producir y cuándo publicar — dos plazos, cero líos en la agenda.",
  },
  tasksRoteiroOpen: {
    narrative: "Cada elemento lleva un guion dentro. Abrirlo es un clic, y el texto ya está ahí.",
    callout: "Centro de contenido / la tarea — el guion vive dentro de ella.",
  },
  tasksRoteiroToolbar: {
    narrative: "Formato de verdad y autoguardado: no hay botón de guardar que se te olvide.",
    callout: "Los comentarios de la marca se quedan en el propio guion, en la línea exacta.",
  },
  tasksRoteiroSheet: {
    narrative: "Gancho, desarrollo y cierre con el tiempo de cada parte — listo para grabar.",
    callout: "El guion que grabas, no un bloc de notas suelto.",
  },
  tasksRoteiroImage: {
    narrative: "La referencia va en mitad del texto: la imagen deja claro el encuadre antes de grabar.",
    callout: "Imagen en mitad del guion, con pie de foto — texto y referencia juntos.",
  },
  tasksRoteiroEnd: {
    narrative: "Y el guion sigue hasta el cierre, con lo que ha pedido la marca ya apuntado.",
    callout: "Baja hasta el final: código de descuento, llamada a la acción y la advertencia de la marca.",
  },
  tasksOutro: {
    narrative: "De la idea al guion terminado, en el mismo sitio donde se sigue la entrega.",
  },
};
